export class Constants {
    static LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS'
    static LOGIN_REQUEST_FAILURE = 'LOGIN_REQUEST_FAILURE'

    static USER_GET_SUCCESS = 'USER_LOAD_BY_AUTH_TOKEN_SUCCESS'
    static USER_GET_FAILURE = 'USER_LOAD_BY_AUTH_TOKEN_FAILURE'

    static DEPOST_POST_SUCCESS = 'DEPOST_POST_SUCCESS'
    static DEPOST_POST_FAILURE = 'DEPOST_POST_FAILURE'

    static GET_SUPPORTED_COINS_SUCCESS = 'GET_SUPPORTED_COINS_SUCCESS'
    static GET_SUPPORTED_COINS_FAILURE = 'GET_SUPPORTED_COINS_FAILURE'

    static DEPOST_STATUS_SUCCESS = 'DEPOST_STATUS_SUCCESS'
    static DEPOST_STATUS_FAILURE = 'DEPOST_STATUS_FAILURE'

    static PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS'
    static PROFILE_UPDATE_FAILURE = 'PROFILE_UPDATE_FAILURE'

    static PAYMENT_WITHDRAW_SUCCESS = 'PAYMENT_WITHDRAW_SUCCESS'
    static PAYMENT_WITHDRAW_FAILURE = 'PAYMENT_WITHDRAW_FAILURE'

    static PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS'
    static PASSWORD_CHANGE_FAILURE = 'PASSWORD_CHANGE_FAILURE'

    static GET_ALL_CREATORS_SUCCESS = 'GET_ALL_CREATORS_SUCCESS'
    static GET_ALL_CREATORS_LOADMORE_SUCCESS =
        'GET_ALL_CREATORS_LOADMORE_SUCCESS'
    static GET_ALL_CREATORS_SUCCESS = 'GET_ALL_CREATORS_SUCCESS'

    static SIGNUP_REQUEST_SUCCESS = 'SIGNUP_REQUEST_SUCCESS'
    static SIGNUP_REQUEST_FAILURE = 'SIGNUP_REQUEST_FAILURE'

    static ALL_TRANSACTION_SUCCESS = 'GET_ALL_TRANSACTION_HISTORY_SUCCESS'
    static ALL_TRANSACTION_FAILURE = 'GET_ALL_TRANSACTION_HISTORY_FAILURE'

    static FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'
    static FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE'

    static CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
    static CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'

    static ACCESS_HISTORY_SUCCESS = 'ACCESS_HISTORY_SUCCESS'
    static ACCESS_HISTORY_FAILURE = 'ACCESS_HISTORY_FAILURE'

    static GET_USERDATA_SUCCESS = 'GET_USERDATA_SUCCESS'
    static GET_USERDATA_FAILURE = 'GET_USERDATA_FAILURE'

    static CREATE_AKOLADE_SUCCESS = 'CREATE_AKOLADE_SUCCESS'
    static CREATE_AKOLADE_FAILURE = 'CREATE_AKOLADE_FAILURE'

    static LOGOUT = 'CLEAR_ALL_STATE_FROM_REDUX'

    static FLASH_MESSAGE = 'FLASH_MESSAGE'
    static FLASH_MESSAGE_CLEAR = 'FLASH_MESSAGE_CLEAR'

    static EMAIL_SUBSCRIPTION_SUCCESS = 'EMAIL_SUBSCRIPTION_SUCCESS'
    static EMAIL_SUBSCRIPTION_FAILURE = 'EMAIL_SUBSCRIPTION_FAILURE'

    static USERDEACTIVATE_SUCCESS = 'USERDEACTIVATE_SUCCESS'
    static USERDEACTIVATE_FAILURE = 'USERDEACTIVATE_FAILURE'

    static CREATOR_CATEGORY_SUCCESS = 'CREATOR_CATEGORY_SUCCESS'
    static CREATOR_CATEGORY_FAILURE = 'CREATOR_CATEGORY_FAILURE'

    static GET_ALL_CREATORS_SUCCESS = 'GET_ALL_CREATORS_SUCCESS'
    static GET_ALL_CREATORS_FAILURE = 'GET_ALL_CREATORS_FAILURE'

    static CONTACTUS_SUCCESS = 'CONTACTUS_SUCCESS'
    static CONTACTUS_FAILURE = 'CONTACTUS_FAILURE'

    static REPORT_FAKE_SUCCESS = 'REPORT_FAKE_SUCCESS'
    static REPORT_FAKE_FAILURE = 'REPORT_FAKE_FAILURE'

    static GET_USER_BALANCE_SUCCESS = 'GET_USER_BALANCE_SUCCESS'
    static GET_USER_BALANCE_FAILURE = 'GET_USER_BALANCE_FAILURE'

    static RESET_PASS_EMAIL_SUCCESS = 'RESET_PASS_EMAIL_SUCCESS'
    static RESET_PASS_EMAIL_FAILURE = 'RESET_PASS_EMAIL_FAILURE'

    static CANCEL_AKOLADE_SUCCESS = 'CANCEL_AKOLADE_SUCCESS'
    static CANCEL_AKOLADE_FAILURE = 'CANCEL_AKOLADE_FAILURE'

    static GET_AKOLADE_SEND_SUCCESS = 'GET_AKOLADE_SEND_SUCCESS'
    static GET_AKOLADE_SEND_FAILURE = 'GET_AKOLADE_SEND_FAILURE'

    static NEW_ACCESS_TOKEN_SUCCESS = 'NEW_ACCESS_TOKEN_SUCCESS'
    static NEW_ACCESS_TOKEN_FAILURE = 'NEW_ACCESS_TOKEN_FAILURE'

    static GET_TOKEN_HISTORY_SUCCESS = 'GET_TOKEN_HISTORY_SUCCESS'
    static GET_TOKEN_HISTORY_FAILURE = 'GET_TOKEN_HISTORY_FAILURE'

    static REVOKE_REFRESH_TOKEN_SUCCESS = 'REVOKE_REFRESH_TOKEN_SUCCESS'
    static REVOKE_REFRESH_TOKEN_FAILURE = 'REVOKE_REFRESH_TOKEN_FAILURE'

    static GET_USERS_REFERRALS_SUCCESS = 'GET_USERS_REFERRALS_SUCCESS'
    static GET_USERS_REFERRALS_FAILURE = 'GET_USERS_REFERRALS_FAILURE'

    static CREATE_APP_SUCCESS = 'CREATE_APP_SUCCESS'
    static CREATE_APP_FAILURE = 'CREATE_APP_FAILURE'

    static GET_APP_LIST_SUCCESS = 'GET_APP_LIST_SUCCESS'
    static GET_APP_LIST_FAILURE = 'GET_APP_LIST_FAILURE'

    static CONFIRM_TXN_SUCCESS = 'CONFIRM_TXN_SUCCESS'
    static CONFIRM_TXN_FAILURE = 'CONFIRM_TXN_FAILURE'

    static APP_PAYMENT_SUCCESS = 'APP_PAYMENT_SUCCESS'
    static APP_PAYMENT_FAILURE = 'APP_PAYMENT_FAILURE'
}
